<template lang="pug">
.comparator-form__result
	h2.sf-heading-1.comparator-form__result__heading Összehasonlítás
	p.sf-text.comparator-form__result-description Egy személygépjármű nyíltvégű vagy zárvégű lízingelése az alábbi  pénzügyi előnyöket nyújtja vállalkozása számára az egyösszegű készpénzes vásárláshoz képest:
	.comparator-form__result-cards
		.comparator-form__result-card(v-for="(calc, index) in shownCards", :key="index")
			.comparator-form__result-card-tag(v-if="calc.name === OPEN_ENDED_RESULT")
				p.sf-text.sf--bold.comparator-form__result-card-tag-label Figyelmébe ajánljuk
			.comparator-form__result-card-heading(:class="{ 'comparator-form__result-card-heading--grey': isOpenOrClosedEnded(calc), 'comparator-form__result-card-heading--green': !isOpenOrClosedEnded(calc) }").comparator-form__result-card-heading--default
				h3.sf-heading-3.comparator-form__result-card-title {{ calc.name }}
				p.sf-text.comparator-form__result-card-price-text(v-if="isOpenOrClosedEnded(calc)") Bruttó vételár
				p.sf-text.comparator-form__result-card-price-text(v-else) csökkentett bruttó ráfordítás
				p.sf-heading-2.comparator-form__result-card-price-text {{ formatCurrency(calc.reducedGrossExpenditure) }}
			.comparator-form__result-card-body
				dl.comparator-form__result-card-list
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--aligned
						dt Bruttó ráfordítás
							VueTooltip(placement="bottom")
								p(slot="content")
									| Bruttó ráfordítás: tőke, ÁFA és kamat, amit a lízingbevevő a futamidő alatt megfizet
						dd.sf--bold {{ formatCurrency(calc.grossExpenditure) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--aligned
						dt Csökkentő tételek
						dd.sf--bold {{ formatCurrency(calc.reducingItems) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Visszaigényelhető áfa
							VueTooltip(placement="bottom")
								p(slot="content")
									| Az ÁFA levonásra jogosult cégek a gépkocsi üzleti célú használatának arányában visszaigényelhetik a lízingdíjak áfa-tartalmát (2007. évi CXXVII. törvény 119-128 §)
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.recoverableVat) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Adókedvezmény
							VueTooltip(placement="bottom")
								p(slot="content")
									| KKV-k esetén a felszámított kamat 100%-a levonható a társasági adóból, a fejlesztési adókedvezménnyel csökkentett társasági adó 70%-áig és levonható az adó alapjából is (költségként).
								p(slot="content")
									br
									| Egyéni vállalkozó az SZJA-ból is levonhatja a beruházási hitel kamatát a fizetendő adóból. (1996. évi LXXXI. Törvény a társasági adóról és osztalékadóról)
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.taxDiscount) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Likviditási többlet hozama
							VueTooltip(placement="bottom")
								p(slot="content")
									| Készpénzes vásárlással szemben pénzügyi lízing finanszírozás esetén a cégben megmaradó tőke a cég tevékenységéből adódóan vagy más befektetésnek köszönhetően hozamot generál. Ennek a futamidő alatti teljes összegét tartalmazza a számítás.
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.extraProfit) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--top-margin
						dt Havi törlesztőrészlet
						dd.sf--bold {{ formatCurrency(calc.monthlyPayment) }}

	.comparator-form__result-cards.comparator-form__result-cards--detailed(v-show="detailedView")
		.comparator-form__result-card(v-for="(calc, index) in shownCards", :key="index", :class="{ 'comparator-form__result-card--detailed--green': !isOpenOrClosedEnded(calc), 'comparator-form__result-card--detailed--grey': isOpenOrClosedEnded(calc) }")
			.comparator-form__result-card-heading.comparator-form__result-card-heading--detailed
				h3.sf-heading-3.comparator-form__result-card-title.comparator-form__result-card-title--detailed {{ calc.name }}
				dl.comparator-form__result-card-list
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--aligned.comparator-form__result-card-list-item--no-margin
						dt Bruttó ráfordítás
							VueTooltip(placement="bottom")
								p(slot="content")
									| Bruttó ráfordítás: tőke, ÁFA és kamat, amit a lízingbevevő a futamidő alatt megfizet
						dd.sf--bold {{ formatCurrency(calc.grossExpenditure) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--aligned
						dt.sf-text-fineprint Bruttó önerő
						dd.sf--bold.sf-text-fineprint   {{ formatCurrency(calc.grossCapital) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--small
						dt - Ebből áfa
						dd {{ formatCurrency(calc.vatContentOfCapital) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Lízingdíj bruttó összege
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.sumOfLeasePayments) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--small
						dt Ebből kamat
						dd {{ formatCurrency(calc.interestContentOfLeasePayments) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--small
						dt Ebből áfa
						dd  {{ formatCurrency(calc.vatContentOfLeasePayments) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--bottom-margin
						dt.sf-text-fineprint Bruttó maradványérték
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.residualValue) }}
					.comparator-form__result-card-list-item.comparator-form__result-card-list-item--top-margin
						dt Csökkentő tételek
						dd.sf--bold {{ formatCurrency(calc.reducingItems) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Visszaigényelhető áfa
							VueTooltip(placement="bottom")
								p(slot="content")
									| Az ÁFA levonásra jogosult cégek a gépkocsi üzleti célú használatának arányában visszaigényelhetik a lízingdíjak áfa-tartalmát (2007. évi CXXVII. törvény 119-128 §)
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.recoverableVat) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Adókedvezmény
							VueTooltip(placement="bottom")
								p(slot="content")
									| KKV-k esetén a felszámított kamat 100%-a levonható a társasági adóból, a fejlesztési adókedvezménnyel csökkentett társasági adó 70%-áig és levonható az adó alapjából is (költségként).
								p(slot="content")
									br
									| Egyéni vállalkozó az SZJA-ból is levonhatja a beruházási hitel kamatát a fizetendő adóból. (1996. évi LXXXI. Törvény a társasági adóról és osztalékadóról)
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.taxDiscount) }}
					.comparator-form__result-card-list-item
						dt.sf-text-fineprint Likviditási többlet hozama
							VueTooltip(placement="bottom")
								p(slot="content")
									| Készpénzes vásárlással szemben pénzügyi lízing finanszírozás esetén a cégben megmaradó tőke a cég tevékenységéből adódóan vagy más befektetésnek köszönhetően hozamot generál. Ennek a futamidő alatti teljes összegét tartalmazza a számítás.
						dd.sf--bold.sf-text-fineprint {{ formatCurrency(calc.extraProfit) }}
			.comparator-form__result-card-body.comparator-form__result-card-body--detailed
				p.sf-text.comparator-form__result-card-price-text(v-if="isOpenOrClosedEnded(calc)") Bruttó vételár
				p.sf-text.comparator-form__result-card-price-text(v-else) csökkentett bruttó ráfordítás
				p.sf-heading-2.comparator-form__result-card-price-text {{ formatCurrency(calc.reducedGrossExpenditure) }}

	VuePagination(v-if="isMobile", v-model="cardPage", :page-size="1", :total-rows="result.leasingComparationList.length", mobile-view="dots")

	button.sf-link.calculation-details-btn.calculation-details-btn--top(@click="toggleDetails") Kalkuláció részletei
		svg(v-if="!detailedView", xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none")
			path(d="M2 6L8 12L14 6" stroke="#52AE30" stroke-linecap="round" stroke-linejoin="round")
		svg(v-if="detailedView", xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none")
			path(d="M14 10L8 4L2 10" stroke="#52AE30" stroke-linecap="round" stroke-linejoin="round")
	button.sf-link.calculation-details-btn(@click="downloadCalculation", :disabled="calculationPending") Kalkuláció letöltése pdf-ben
		svg(xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none")
			path(d="M8.5 1L8.50124 10.3876M5.5 7.5L8.5 10.5L11.5 7.5M10.7929 4L12.1667 4C12.6529 4 13.1192 4.18543 13.463 4.51549C13.8068 4.84556 14 5.29322 14 5.76L14 13.24C14 13.7068 13.8068 14.1544 13.463 14.4845C13.1192 14.8146 12.6529 15 12.1667 15L4.83333 15C4.3471 15 3.88079 14.8146 3.53697 14.4845C3.19315 14.1544 3 13.7068 3 13.24L3 5.76C3 5.29322 3.19315 4.84556 3.53697 4.51549C3.88079 4.18543 4.3471 4 4.83333 4L6.20833 4" stroke="#52AE30" stroke-linecap="round" stroke-linejoin="round")

	portal(to="modal-outlet")
		VueModal(:modal-id="MODAL_ID", width="narrow", role="dialog", closePopupText="kalkuláció letöltése modal bezárása")
			template(slot="modal-header")
				h2.sf-heading-2 Kalkulált adatok letöltése
			template(slot="modal-body")
				VueCaptcha#lc-captcha-text(v-model="model.captchaText", :max-length="5", :img="`data:image/jpeg;base64,${captchaImg}`", :has-error="hasError('captchaText')", :aria-describedby="hasError('captchaText') ? 'id' : null", :max-width="104", @keyup="resetCaptchaError", @blur="validateField('captchaText')")
				VueErrorMessage#lc-captcha-text-err(v-if="hasError('captchaText')") {{ getErrorMessage('captchaText') }}
			template(slot="modal-footer")
				VueButton(@click="confirmDownload", :disabled="downloadInProgress") Letöltés
</template>

<script>
import { useDownloadFile } from '../../../common/js/composables/download-file';
import leasingComparatorApi from '../../../api/leasing-comparator-api';
import { useCaptcha } from '../../../common/js/composables/captcha';
import { defineComponent, reactive, ref, watch, computed } from 'vue';
import VueTooltip from '@ui-common/vue-tooltip';
import { useStore } from '../store';
import { useConstants } from '../composables/constants';
import VuePagination from '@ui-common/vue-pagination';
import { isMobile } from '@ui-common/sf-js-utils';
import { required, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useErrorHandlerUtils } from '../../../common/js/composables/error-handler';
import VueCaptcha from '@ui-common/vue-captcha';
import VueButton from '@ui-common/vue-button';
import VueErrorMessage from '@ui-common/vue-error-message';

const MODAL_ID = 'leasing-comparator-calculation-download';

export default defineComponent({
	mixins: [isMobile],
	emits: ['error'],
	setup(props, { emit }) {
		const { OPEN_ENDED_RESULT, CLOSED_ENDED_RESULT } = useConstants();
		const { result } = useStore();
		const { captchaError, technicalError, captchaImg, captchaKey, loading: calculationPending, getCaptcha, resetCaptchaError } = useCaptcha(
			leasingComparatorApi.generateCaptcha
		);
		const { downloadFile } = useDownloadFile();

		const isOpenOrClosedEnded = calc => calc.name !== OPEN_ENDED_RESULT && calc.name !== CLOSED_ENDED_RESULT;

		const formatCurrency = value => {
			if (isNaN(parseInt(value))) {
				return '-';
			}
			return new Intl.NumberFormat('hu', { style: 'currency', currency: 'HUF', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
		};

		const detailedView = ref(false);
		const toggleDetails = () => (detailedView.value = !detailedView.value);

		watch(technicalError, val => {
			if (val) emit('error');
		});

		const cardPage = ref(1);

		const downloadInProgress = ref(false);
		const model = reactive({
			captchaText: null
		});
		const rules = computed(() => ({
			captchaText: {
				required: captchaImg.value ? helpers.withMessage('A kód megadása kötelező.', required) : {},
				captcha: captchaImg.value ? helpers.withMessage('A kód nem megfelelő.', () => captchaError.value === false) : {}
			}
		}));
		const v = useVuelidate(rules, model);
		const { hasError, validateField, getErrorMessage } = useErrorHandlerUtils(v);

		return {
			result,
			getCaptcha,
			captchaImg,
			captchaKey,
			downloadFile,
			captchaError,
			formatCurrency,
			OPEN_ENDED_RESULT,
			CLOSED_ENDED_RESULT,
			detailedView,
			toggleDetails,
			MODAL_ID,
			cardPage,
			calculationPending,
			hasError,
			validateField,
			getErrorMessage,
			model,
			resetCaptchaError,
			VueErrorMessage,
			v,
			downloadInProgress,
			isOpenOrClosedEnded
		};
	},
	computed: {
		shownCards() {
			return this.isMobile ? [this.result.leasingComparationList[this.cardPage - 1]] : this.result.leasingComparationList;
		}
	},
	methods: {
		async downloadCalculation(event) {
			this.model.captchaText = null;
			this.v.captchaText.$reset();
			await this.getCaptcha();
			if (this.captchaImg) {
				this.$openModal(event, MODAL_ID);
				return;
			}
			const sentModel = { ...this.result.calculatedModel };
			sentModel.captchaKey = this.captchaKey;
			sentModel.captchaText = null;
			try {
				await this.downloadFile(leasingComparatorApi.generatePdf(sentModel));
			} catch {
				this.$emit('error');
			}
		},
		async confirmDownload() {
			this.downloadInProgress = true;
			const sentModel = { ...this.result.calculatedModel };
			sentModel.captchaKey = this.captchaKey;
			sentModel.captchaText = this.model.captchaText;
			try {
				await this.downloadFile(leasingComparatorApi.generatePdf(sentModel));
				this.$closeModal(MODAL_ID);
			} catch (error) {
				if (error?.response?.data?.error === 'captchaText') {
					this.captchaError = true;
				} else {
					this.$emit('error');
				}
				return;
			} finally {
				this.downloadInProgress = false;
			}
		}
	},
	components: {
		VueTooltip,
		VuePagination,
		VueCaptcha,
		VueButton,
		VueErrorMessage
	}
});
</script>

<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.comparator-form__result__heading {
	margin-bottom: 24px;

	@include media('<tablet') {
		margin: 0 24px 24px;
	}
}

.comparator-form__result-description {
	margin-bottom: 40px;

	@include media('<tablet') {
		margin: 0 24px 36px 24px;
	}
}

.comparator-form__result-cards {
	align-items: center;
	display: flex;
	gap: 32px;
	margin-bottom: 32px;

	@include media('<desktop-lg') {
		display: grid;
		grid-template-columns: 352px 352px;
	}

	@include media('<tablet') {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
}

.comparator-form__result-cards--detailed {
	@include media('<tablet') {
		margin-bottom: 24px;
	}
}

.comparator-form__result-card {
	background-color: $white;
	border-radius: 24px;
	box-shadow: 0 16px 48px 0 $contour-blue-shadow;
	position: relative;
	width: 352px;

	@include media('<tablet') {
		max-width: 328px;
		min-width: 320px;
		width: 100%;
	}
}

.comparator-form__result-card--detailed--green {
	background-color: $content-green;
}

.comparator-form__result-card--detailed--grey {
	background-color: $contentBg-gray-4;
}

.comparator-form__result-card-tag {
	background-color: $orange;
	border-radius: 12px;
	padding: 8px 24px;
	position: absolute;
	right: 24px;
	top: -16px;

	.sf-text {
		color: $white;
		line-height: 16px;
		margin: 0;
	}
}

.comparator-form__result-card-heading {
	background-color: $content-green;
	border-radius: 24px;
	padding: 24px;
	text-align: center;
}

.comparator-form__result-card-heading--grey {
	background-color: $contentBg-gray-4;
}

.comparator-form__result-card-heading-green {
	background-color: $content-green;
}

.comparator-form__result-card-title {
	margin-bottom: 8px;
}

.comparator-form__result-card-price-text {
	margin-bottom: 0;
}

.comparator-form__result-card-body {
	border-radius: 0 0 24px 24px;
	padding: 24px 16px;
}

.comparator-form__result-card-list {
	display: flex;
	flex-direction: column;
	font-size: 14px;
	gap: 4px;

	dt,
	dd {
		height: 16px;
	}
}

.comparator-form__result-card-list-item {
	display: flex;
	height: 24px;
	justify-content: space-between;

	&:first-child {
		margin-bottom: 12px;
	}
}

.comparator-form__result-card-heading--detailed {
	background-color: $white;
	padding: 24px 16px;
}

.comparator-form__result-card-heading--green {
	background-color: $content-green;
}

.comparator-form__result-card-list-item--top-margin {
	margin-top: 12px;
}

.calculation-details-btn {
	cursor: pointer;
	width: 100%;

	svg {
		margin-bottom: -2px;
		margin-left: 4px;
	}
}

.calculation-details-btn--top {
	margin-bottom: 16px;

	@include media('<tablet') {
		margin-top: 24px;
	}
}

.comparator-form__result-card-body--detailed {
	padding: 24px;
	text-align: center;
}

.comparator-form__result-card-title--detailed {
	margin-bottom: 24px;
}

.comparator-form__result-card-list-item--aligned {
	align-items: center;
	display: flex;

	.sf-text-fineprint {
		margin-bottom: 0;
	}
}

.comparator-form__result-card-list-item--small {
	color: $text-secondary;
	font-style: italic;
	height: 16px;
	line-height: 16px;
	margin-left: 12px;
}

.comparator-form__result-card-list-item--no-margin:first-child {
	margin-bottom: 0;
}

:deep(.sf-modal-content--white) {
	@include media('<tablet') {
		height: 100vh;
	}
}
</style>
